const validate = (values) => {
  const attrs = values || {};
  const errors = {};

  if (!attrs.nombre) {
    errors.nombre = 'Debe ingresar un nombre para la malla';
  }

  if (!attrs.carrera || !attrs.carrera.value) {
    errors.carrera = 'Debe seleccionar la carrera';
  }

  if (!attrs.fechaVigencia) {
    errors.fechaVigencia = 'Debe seleccionar la fecha de vigencia';
  }

  return errors;
};

export default validate;
